import { FC } from "react";

interface ConsidferacoesAlteracoesObrigacoesContinuacaoProps {}

const ConsidferacoesAlteracoesObrigacoesContinuacao: FC<ConsidferacoesAlteracoesObrigacoesContinuacaoProps> = () => {
    return <>
        <div className="sub-title-minor">O Grupo Intelbras não se responsabiliza por:</div>

        <div className="container-prazo-entrega">
            <div className="item-prazo-entrega">
                <div className="marcador-prazo-entrega" >»</div>
                <div className="texto-prazo-entrega">Perdas;</div>
            </div>
            <div className="item-prazo-entrega">
                <div className="marcador-prazo-entrega" >»</div>
                <div className="texto-prazo-entrega">Despesas;</div>
            </div>
            <div className="item-prazo-entrega">
                <div className="marcador-prazo-entrega" >»</div>
                <div className="texto-prazo-entrega">Danos diretos e indiretos causados durante as atividades abaixo, seja no período da garantia ou não:</div>
            </div>
            <div className="item-prazo-entrega">
                <div className="marcador-prazo-entrega marcador-prazo-entrega-margin">-</div>
                <div className="texto-prazo-entrega">Instalação;</div>
            </div>
            <div className="item-prazo-entrega">
                <div className="marcador-prazo-entrega marcador-prazo-entrega-margin">-</div>
                <div className="texto-prazo-entrega">Manutenção;</div>
            </div>
            <div className="item-prazo-entrega">
                <div className="marcador-prazo-entrega marcador-prazo-entrega-margin">-</div>
                <div className="texto-prazo-entrega">Problemas em equipamentos de outra fabricação e marca.</div>
            </div>
        </div>
        <div className="default-text-list"><span>Esta proposta contempla exclusivamente os produtos conforme as especificações técnicas e informações fornecidas pelo cliente até o momento da sua emissão. Eventuais necessidades de adequação do sistema, incluindo, mas não se limitando à inclusão de dispositivos de desligamento rápido (RSD), substituição ou complementação de equipamentos, ou aquisição de componentes adicionais exigidos por normas estaduais, municipais ou por exigências específicas de órgãos públicos (como o Corpo de Bombeiros), não estão incluídas nesta proposta/contrato e deverão ser objeto de contratação e negociação à parte.</span></div>
        <div style={{ marginTop: "10pt" }}></div>
        <div className="default-text-list"><span>Portanto, o Grupo Intelbras não se responsabiliza pela aquisição, fornecimento, instalação ou regularização de tais itens adicionais, cabendo ao cliente e/ou à revenda parceira a responsabilidade integral por sua obtenção, negociação comercial, instalação e atendimento às exigências dos órgãos competentes. Inclusive, a Intelbras não se responsabiliza por eventual indeferimento de projetos, licenças, autuações ou negativas de operação por ausência de itens não incluídos nesta proposta e configuração de dispositivo para limitação de energia injetada (Grid Zero), devendo o cliente e/ou prestador de serviço contratado específico adotar as providências cabíveis para o atendimento integral das normativas vigentes.</span></div>

        <div className="sub-title-minor">Alterações no projeto</div>

        <div className="default-text-list"><span>Toda e qualquer mudança no projeto ou serviço inicial, que implique em alterações de características específicas solicitadas pelo cliente, como:</span></div>

        <div className="container-prazo-entrega">
            <div className="item-prazo-entrega">
                <div className="marcador-prazo-entrega" >»</div>
                <div className="texto-prazo-entrega">Funções adicionais;</div>
            </div>
            <div className="item-prazo-entrega">
                <div className="marcador-prazo-entrega" >»</div>
                <div className="texto-prazo-entrega">Reinstalação;</div>
            </div>
            <div className="item-prazo-entrega">
                <div className="marcador-prazo-entrega" >»</div>
                <div className="texto-prazo-entrega">Ampliação.</div>
            </div>
        </div>

        <div className="default-text-list"><span>Entre outros itens não especificados, serão considerados como adicionais e devem seguir o cronograma de execução do projeto, bem como a alocação de recursos através da nova proposta técnica-comercial.</span></div>
    </>
}

export default ConsidferacoesAlteracoesObrigacoesContinuacao;